import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {getStepMetadataContent} from 'analysis-tool/data-view/analysis-adapter/getAnalysisViewMetadataContent';
import {AdditionalDataFrameMetadataContents} from 'data-frames/modals/PersistedDataFrameMetadataModal';
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStep} from 'pipelines/PipelineTypes';
import {getPipelineStepRawDatasOfKind} from 'pipelines/StepDataUtils';
import Col from 'ui-library/bs/Col';
import FormGroup from 'ui-library/bs/FormGroup';
import Row from 'ui-library/bs/Row';
import FieldLabel from 'ui-library/inputs/FieldLabel';
import ImmutableSet from 'util/ImmutableSet';

import {MAX_POPOVER_HEIGHT, MAX_POPOVER_WIDTH} from './PopoverConstants';

export const TABLE_CREATION_POPOVER_SUPPORTED_STEP_TYPES = new ImmutableSet([
  PipelineStepType.CONNECTION_DATA_DATASET,
  PipelineStepType.DATA_CATALOG_DATASET,
  PipelineStepType.INITIALIZE_DATASET,
  PipelineStepType.JOIN,
  PipelineStepType.NOTEBOOK_TABLE_DATASET,
  PipelineStepType.REGISTRY_SCHEMA_DATASET,
  PipelineStepType.UPLOAD_CSV_DATASET,
]);

export default function TableCreationPopoverContents({step}: {step: PipelineStep}): JSX.Element {
  const dataFrame = getPipelineStepRawDatasOfKind(PipelineStepDataKind.DATASET, step.outputStepDatas[0])[0];

  return (
    <div className={css(styles.wrapper)}>
      {dataFrame && (
        <Row>
          <Col sm={12}>
            <FormGroup>
              <FieldLabel label="Name" />
              <p>{dataFrame.name}</p>
            </FormGroup>
          </Col>
        </Row>
      )}
      <AdditionalDataFrameMetadataContents {...getStepMetadataContent(step)} />
    </div>
  );
}

const PADDING = 10;

const styles = StyleSheet.create({
  wrapper: {
    padding: PADDING,
    margin: PADDING,
    width: MAX_POPOVER_WIDTH - PADDING,
    maxHeight: MAX_POPOVER_HEIGHT,
  },
});
